import history from "../utils/history";

export function onRedirectCallback(appState) {
    history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
}
